(function() {
	'use strict';

	angular
		.module('app.setup')
		.service('supplierPortalConfigService', supplierPortalConfigService);

	supplierPortalConfigService.$inject = ['$http', 'URLS'];

	function supplierPortalConfigService($http, URLS) {
		var service = {
			getSupplierPortalComponents: getSupplierPortalComponents
		};
		return service;

		function getSupplierPortalComponents() {
			return $http.get('/api/2/SupplierPortalComponents')
				.then(getSupplierPortalComponentsSuccess, handleError);

			function getSupplierPortalComponentsSuccess(response) {
				return response.data;
			}
		}

		function handleError (error) {
			if (error.status === 403) {
				return '';
			} else if (error.status === 412) {
				return error.data.error;
			}
			return 'Unknown server error';
		}
	}
})();
